import React from 'react';

import { ClickableText } from 'src/components/common/clickableText/ClickableText';
import { DocsRouter } from 'src/lib/routers';

export const OperationSignatureTooltip = () => (
  <p>
    The operation signature represents the shape of the query that was captured
    by Apollo. Studio records queries in a{' '}
    <ClickableText
      target="_blank"
      rel="noopener noreferrer"
      className="text-inverted underline"
      href={DocsRouter.path('OperationSignatures')}
      as="a"
    >
      normalized “signature” form
    </ClickableText>{' '}
    by default, which may look somewhat different than the original query.
  </p>
);
